module.exports = __webpack_public_path__ + "static/media/Cart_remove.4af7dc28.svg";